import { getCurrentApiBaseUrl } from '@/features/warehouse/config'

export type ImageSizePreference = 'thumb' | 'medium' | 'original'

export type ImageLike =
  | string
  | {
      thumb?: string
      thumbnail?: string
      medium?: string
      original?: string
      url?: string
      image?: string
    }
  | null
  | undefined

function pickImageCandidate(input: ImageLike, prefer: ImageSizePreference): string | undefined {
  if (!input) return undefined
  if (typeof input === 'string') return input
  if (typeof input !== 'object') return undefined

  const orderedKeys =
    prefer === 'original'
      ? ['original', 'medium', 'thumb', 'thumbnail', 'url', 'image']
      : prefer === 'medium'
        ? ['medium', 'original', 'thumb', 'thumbnail', 'url', 'image']
        : ['thumb', 'thumbnail', 'medium', 'original', 'url', 'image']

  const candidate = orderedKeys
    .map((key) => input[key as keyof typeof input])
    .find((val): val is string => typeof val === 'string' && val.length > 0)

  return typeof candidate === 'string' ? candidate : undefined
}

export function resolveImageUrl(
  input: ImageLike,
  prefer: ImageSizePreference = 'thumb'
): string {
  const url = pickImageCandidate(input, prefer)
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  const apiBaseUrl = getCurrentApiBaseUrl()
  if (apiBaseUrl && url.startsWith('/')) return `${apiBaseUrl}${url}`
  return url
}

export function resolveImageUrls(
  urls: ImageLike[] | undefined,
  prefer: ImageSizePreference = 'thumb'
): string[] {
  if (!urls?.length) return []
  return urls.map((url) => resolveImageUrl(url, prefer)).filter(Boolean)
}
